
<template>
  <div class="home">
    <div class="top">
      <div class="titles">
        <!-- <img class="cancel-btn" src="../../assets/images/cancel.png" alt=""> -->
        <!-- <div>推推联盟</div> -->
        <!-- <img class="share-btn" src="../../assets/images/share_btn.png" alt=""> -->
      </div>
      <div class="user-info">
        <img  class="user-img" :onerror="errorImage" :src="info.photo" alt="">
        <div class="user-name">
          <!-- <div class="name">{{info.nickName}}<img @click="goNext('/certification')" src="../../assets/images/authened.png"></div> -->
          <div class="other-info">
            <div class="code-box" >
              <span>{{info.nickName}}</span>
              <div v-clipboard:copy="info.id" v-clipboard:success="onSuccess" v-clipboard:error="onError">
                {{info.id}}
              <img src="../../assets/images/copy2.png"/>
              </div>
            </div>
            <div class="other-msg" @click="getTel">
              <img src="../../assets/images/new/service.png" alt="">
              联系客服
            </div>
          </div>
        </div>
      </div>
      <div class="taps">
        <div class="each-tap" v-for="item in taps" :key="item.value" @click="goNextNew(item)">
          <div class="value">{{item.value}}</div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
      <div class="other-taps">
        <!-- <div class="tapstop"><span>完成实名认证，更多福利等着您</span><div @click="goNext('/certification')">去认证</div></div> -->
        <div class="tabs-box">
          <div class="each-taps" v-for="item in tablist" :key="item.name" @click="goNextNew(item)">
            <div class="num">{{item.num}}</div>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="share">
      <div class="share-title flex-c-c">
        <img src="../../assets/images/new/left-dian.png" alt=""> <span>分享赚钱</span><img src="../../assets/images/new/right-dian.png" alt=""> 
      </div>
      <div class="share-box">
        <div class="share-one" @click.stop="goThread">
          <div class="share-btn"></div>
        </div>
        <div class="share-two" @click.stop="goShare">
          <div class="share-btn"></div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="share-title flex-c-c">
        <img src="../../assets/images/new/left-dian.png" alt=""> <span>多推多赚</span><img src="../../assets/images/new/right-dian.png" alt=""> 
      </div>
      <div class="sub-title">推荐成功得积分</div>
      <div class="list-box">
        <div class="list-bg flex-c-s">
          <div class="left-img">
            <img src="../../assets/images/new/list-img.png" alt="">
          </div>
          <div class="right">
            <div class="right-top">
              <div class="each-user">
                <div class="user">成功推荐1-3个新客户</div>
                <div class="jifen">每笔可得成交金额 <span>8%</span> 现金积分</div>
              </div>
              <div class="each-user">
                <div class="user">成功推荐4-10个新客户</div>
                <div class="jifen">每笔可得成交金额<span>10%</span>现金积分</div>
              </div>
              <div class="each-user">
                <div class="user">成功推荐11个及以上新客户</div>
                <div class="jifen">每笔可得成交金额<span>12%</span>现金积分</div>
              </div>
            </div>
            <div class="right-bottom">
              <div class="tip">*100积分=1元人民币</div>
              <div class="tip">*新客户需在推荐绑定前从未在系统内注册试用过方可作为有效线索</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exchange">
      <div class="share-title flex-c-c">
        <img src="../../assets/images/new/left-dian.png" alt=""> <span>积分兑换</span><img src="../../assets/images/new/right-dian.png" alt=""> 
      </div>
      <div class="sub-title">可兑换：现金 购物卡 礼品</div>
      <div class="exchange-money">
        <div class="exchange-title">100积分 = 1元人民币</div>
        <div class="exchange-subtitle">10000积分起兑换，以百元为单位进行兑换</div>
        <div class="msgs flex-s-s">
          <div class="xing">*</div>
          <div class="tips">兑换须知：因税务要求，800元以上现金赠与需兑换人承担个人所得税20%</div>
        </div>
      </div>
      <div class="exchange-card">
        <div class="msgs">*等额现金购物卡，每次最多可兑换800元等额购物卡</div>
        <div class="card-main img-box">
          <img :src="cardImg" alt="">
        </div>
      </div>
      <div class="exchange-card exchange-other">
        <div class="msgs"></div>
        <div class="card-main card-main-banner">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="red">
            <van-swipe-item v-for="item in imgList" :key="item.coverPic">
              <img :src="item.coverPic" alt="">
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <div class="bottom-msg">
      <span><span class="bottom-title">兑换须知：</span><span class="bg">请联系您的销售人员</span>（邀请您加入推推联盟的联络人）<span class="bg">进行积分核销兑换，</span>我们将在审核完成后为您兑换相应的权益并扣除相应可用积分</span>
      <div class="bottom-phone"><img src="../../assets/images/new/tel.png" alt=""> 客服电话：请点击上方“联系客服”</div>
    </div>
  </div>
</template>

<script type="text/babel">
import MainButton from '@/component_basics/MainButton';
import BaseTip from '@/component_basics/BaseTip';
import Head from '@/component_basics/Head';
import {ls} from '@/utils/localStorage'
import jsSha from 'jssha'

// 组件
export default {
  name: 'home',
  components: {
    Head,
    BaseTip,
  },
  data() {
    return {
      headInfo:{
        name: '提现'
      },
      cardImg:"",
      errorImage: require('../../assets/images/defalut_head.png'),
      info:{
      },
      imgList:[],
      licensecode:'',
      refereeId: '',
      taps:[
        {
          name:'可用积分',
          value:'--',
          url:'/jifen'
        },{
          name:'已使用积分',
          value:'--',
          url:'/jifen'
        },{
          name:'累计积分',
          value:'--',
          url:'/jifen'
        }
      ],
      wxInfo:{},
      tablist:[
        {
          num: '0',
          name:'已推荐(个)',
          url:'/userList'
        },{
          num: '0',
          name:'已购买(个)',
          url:'/userList'
        },{
          num: '0',
          name:'试用中(个)',
          url:'/userList'
        }
      ],
    };
  },
  created() {
    // if(!this.$route.query.config) {
      this.getAppId()
    // }
    this.getUserInfo()
    this.getData(234)
    this.getData(235)
  },
  methods: {
    getUserInfo() {
      let param = {
        // refereeId: this.refereeId
      }
      this.$services.getTkDataById({method:'post',data:param}).then(res=> {
      
      // 赋值
      let data = res.data[0]||{}
      ls.set('userInfo', data)
      this.info = res.data[0]|| {}
      if(!this.info.photo) {
        this.info.photo = this.defaultHeadImg
      }
      this.taps[0].value=data.availableIntegral
      this.taps[1].value=data.useIntegral
      this.taps[2].value=data.allIntegral
      this.tablist[0].num = data.clueUserCount
      this.tablist[1].num = data.buyCompanyCount
      this.tablist[2].num = data.tryCompanyCount 
    })
    }, 
    goThread() {
      this.$router.push('/threadList')
    },
    onSuccess() {
      this.$toast.success('复制成功')
    },
    getData(key) {
      let params = {
        siteId:18,
        // typeKey:key,
            typeId:1,
            pageSize:10,
            pageIndex:0,
         typeId:key
      }
      this.$services.getDetailByTypeKey({
        method:"POST",
        data:params,
        type:"json"
        // params
      }).then(res=> {
        if(res.code==0) {
          if(key==234) {
            let imgarr=res.data[0].coverPic.split("/")
            this.cardImg = res.data[0].coverPic
          } else {
            res.data.forEach(item=> {
              let imgarr = item.coverPic.split("/")
              item.imgUrl = 'https://home.qiniu.wsgjp.com/test_WebSiteSource/images/'+imgarr[imgarr.length-1]
            })
            this.imgList = res.data
          }
        }
      })
    },
    onError() {
      this.$toast.fail('复制失败,请稍后重试！')
    },
    getTel() {
      let _this = this
      if(!_this.info.salePhone) {
        
        this.$toast.fail('销售人员电话有误！')
      } else {

        window.location.href = "tel:"+_this.info.salePhone
      }
    },
    getAppId() {
          this.$services.getAppId().then(res=> {
              this.wxInfo = res.data
              this.getWxCofig()
          })
      },
      goShare() {
        
        this.$toast.fail({message:'点击右上角菜单分享',duration:3000})
        let _this = this
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    //分享朋友
                wx.updateAppMessageShareData({ 
                   title: '填写手机号，免费试用15天', // 分享标题
                   desc: '简单易用的进销存软件，电脑手机双操作，有网即用', // 分享描述
                   link: `http://${location.host}/index.html#/threadUser?id=${_this.info.id}&saleId=${_this.info.saleId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                   imgUrl: 'http://refereestage.zhangyuxia.com.cn/img/logo.png', // 分享图标
                })
        })
      },
      share() {
        
        let _this = this
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    //分享朋友
                wx.updateAppMessageShareData({ 
                   title: '填写手机号，免费试用15天', // 分享标题
                   desc: '简单易用的进销存软件，电脑手机双操作，有网即用', // 分享描述
                   link: `http://${location.host}/index.html#/threadUser?id=${_this.info.id}&saleId=${_this.info.saleId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                   imgUrl: 'http://refereestage.zhangyuxia.com.cn/img/logo.png', // 分享图标
                })
        })
      },
    getWxCofig() {
          this.$services.getConfig({method:'get',params:{type:'jsapi'}}).then(res=> {
              this.wx(res)
          })
      },
    wx(res) {
           let _this = this
            let nonce = Math.random().toString(36).substr(2, 15);
            this.nonceString = nonce 
            let time = parseInt(new Date().getTime() / 1000)
            if(window.location.href.indexOf('from') != -1 || window.location.href.indexOf('isappinstalled') != -1){
                // 二次分享url重定向 - 需要截取一次分享后微信自动拼接的url参数&from=singlemessage&isappinstalled=0
                window.location.href = window.location.href.split('?')[0]+"#"+window.location.href.split('#')[1];  // 这里的split中的字符串会变换（?或&），主要看自己的url
            }
            let str = `jsapi_ticket=${res.data}&noncestr=${nonce}&timestamp=${time}&url=${location.href.split('#')[0]}`
            let sign = new jsSha(str,'TEXT')
            wx.config({
                debug:false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: _this.wxInfo.appId,
                timestamp: time, // 必填，生成签名的时间戳
                nonceStr: nonce, // 必填，生成签名的随机串
                signature: sign.getHash('SHA-1', 'HEX'),// 必填，签名
                jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline'], // 必填，需要使用的JS接口列表
                
              });
             wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                //分享朋友
                   wx.updateAppMessageShareData({ 
                   title: '填写手机号，免费试用15天', // 分享标题
                   desc: '简单易用的进销存软件，电脑手机双操作，有网即用', // 分享描述
                   link: `http://${location.host}/index.html#/threadUser?id=${_this.info.id}&saleId=${_this.info.saleId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                   imgUrl: 'http://refereestage.zhangyuxia.com.cn/img/logo.png', // 分享图标
                })
          })
        },
        goNextNew(item) {
          this.$router.push({ 
            path:item.url
          })
        },
    goNext(url) {
      
      this.$router.push({ 
        path:url
      })
    }
  }
};
</script>

<style lang="less">
  .home{
    width: 100%;
    min-height: 100%;
    background-color: #fef3e5;
     .share-title{
        color: @colorFont;
        font-size: 24px;
        font-weight: bold;
        img{
          width: 17px;
          height: 10px;
        }
        span{
          margin: 0 14px;
        }
      }
      .sub-title{
        font-size: 15px;
        margin-bottom: 15px;
        margin-top: 6px;
        opacity: 0.75;
      }
    .top{
      background: url('../../assets/images/new/top-bg.png') no-repeat;
      background-size: 100% 140%;
      background-position-y: -150px;
      height: 260px;
      .titles{
        display: flex;
        justify-content: center;
        align-items: center;
        // height: 24px;
        padding: 10px 23px;
        color: #fff;
        font-size: 18px;
        
        .cancel-btn{
          width: 17px;
          height: 17px;
        }
        .share-btn{
          width: 18px;
          height: 18px;
        }

      }
      .user-info{
        display: flex;
        padding: 0 23px;
        margin-top: 20px;
        .user-img{
          border-radius: 50%;
        }
        &>img{
          width: 55px;
          height: 55px;
          margin-right: 7px;
        }
        .user-name{
          display: flex;
          
          align-items: center;
          justify-content: stretch;
          flex: 1;
          .name{
            display: flex;
            justify-content:flex-start;
            align-items: center;
            color: #fff;
            font-size: 17px;
            &>img{
              width: 57px;
              height: 22px;
            }
          }
          .other-info{
            display: flex;
            justify-content: space-between;
            align-self: stretch;
            align-items: center;
            flex: 1;
            .code-box{
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              span{

                font-size: 20px;
                padding: 4px 6px;
                border-radius: 9px;
                font-weight: bold;
                color: #fff;
                opacity: 0.97;
              }
              div{
                font-size: 16px;
                color: #fff;
                background-color: #F83A30;
                padding: 2px 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                img{
                  width: 16px;
                  height: 16px;
                  margin-left: 3px;
                }
              }
            }
            .other-msg{
              color: #fff;
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 110px;
              height: 32px;
              background: rgba(255, 255, 255, 0.25);
              border-radius: 32px;
              padding: 0 10px;
              img{
                width: 26px;
                height: 26px;
                margin-right: 5px;
              }
            }
          }
        }
      }
      .taps{
        
        display: flex;
        padding: 0 23px;
        margin-top: 12px;
        .each-tap{
          flex: 1;
          color: #fff;
          overflow: hidden;
          .value{
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 13px;
          }
          .name{
            font-size: 12px;
          }
        }
      }
      .other-taps{
        margin: 0px 13px;
        display: flex;
        flex-direction: column;
        position: relative;
        .tapstop{
          // padding: 9px 18px;
          display: flex;
          justify-content: space-between;
          background: url('../../assets/images/aut.png')no-repeat;
          background-size: 100%;
          font-size: 12px;
          color: #786A4D;
          &>div{
            height: 17px;
            width: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            border: 1px solid #786A4D;
          }
        }
      }
      .tabs-box{
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        padding: 15px 18px;
        background: url('../../assets/images/total_bg.png')no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0px;
        left: -5px;
        width: 103%;
        // height: 140px;
        .each-taps{
          flex: 1;
          .num{
            font-size: 32px;
            color: #F83A30;
            font-weight: bold;
            // margin-bottom: 12px;
          }
          .name{

          }
        }
      }
    }
    .share{
      padding: 13px;
     
      .share-box{
        margin-top: 18px;
        .share-one{
          background: url('../../assets/images/new/share-one.png')no-repeat;
          background-size: 100%;
          // width: 168px;
          height: 98px;
          position: relative;
        }
        .share-btn{
          position: absolute;
          width: 100px;
          height: 40px;
          right: 20px;
          top: 40px;
        }
        .share-two{
          background: url('../../assets/images/new/share-two.png')no-repeat;
          background-size: 100%;
          // width: 168px;
          height: 98px;
          margin-top: 17px;
          position: relative;
          .left-title{
            color: #7C5C36;
            font-size: 15px;
            margin-bottom: 8px;
          }
          .left-url{
            color: #B2986F;
            font-size: 12px;
          }
        }
      }
    }
    .list{
      margin: 15px;
      .list-title{
        font-size: 15px;
        color: @colorFont;
        margin-bottom: 13px;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
      }
      .list-box{
        background: url(../../assets/images/new/get-more.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 33px 14px;
        .left-img{
          img{

            height: 200px;
            width: 12px;
            margin-right: 20px;
            margin-top: 30px;
          }
        }
        .each-user{
          background-color: #FEF3E5;
          padding: 10px 12px;
          margin-bottom: 20px;
          div{
            text-align: left;
          }
          .user{
            font-size: 18px;
            font-family: Noto Sans S Chinese;
            font-weight: bold;
            color: #000000;
          }
          .jifen{
            font-size: 15px;
            font-family: Noto Sans S Chinese;
            font-weight: 400;
            color: #6A6969;
            span{
              font-size: 24px;
              font-weight: bold;
              color: #FB323F;
            }
          }
        }
        .right-bottom{
          text-align: left;
          color: #CD7900;
        }
      }
    }
    .exchange{
      margin: 15px;
      .exchange-money{
        padding: 50px 14px 20px 14px;
        background: url('../../assets/images/new/getmoney.png')no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .exchange-title{
          padding: 7px 20px;
          background: #FB323F;
          border-radius: 31px;
          font-size: 18px;
          font-family: 060-CAI978;
          font-weight: 400;
          color: #FFFFFF;
        }
        .exchange-subtitle{
          font-size: 14px;
          font-family: Noto Sans S Chinese;
          font-weight: 400;
          color: #22201E;
        }
        .msgs{
          margin-top: 16px;
          color: #CD7900;
          div{
            text-align: left;
          }
        }
      }
      .exchange-card{
        background: url(../../assets/images/new/get-card.png) no-repeat;
        background-size: 100% 100%;
        padding: 46px 15px;
        margin-top: 23px;
        .msgs{
          color: #CD7900;
        }
        .card-main{
          height: 200px;
        }
          .img-box{
            img{
              height: 100%;
              width: 100%;
            }
          }
        
      }
      .exchange-other{
        
        background: url(../../assets/images/new/getother.png) no-repeat;
        background-size: 100% 100%;
        padding: 50px 15px 40px 15px;
        
        .card-main-banner{
          height: 240px;
          .van-swipe{
            .van-swipe__indicators{
              bottom: -20px;
            }
          }
        }
        .my-swipe {
          height: 100%;
          .van-swipe-item {
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            img{
              height: 100%;
              width: 100%;
            }
          }
        }
      }
    }
    .bottom-msg{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 14px;
      >span{

        text-align: left;
      }
      .bottom-title{
        font-weight: bold;

      }
      .bg{
        background: #FECE69;
      }
      .bottom-phone{
        color: #CD7900;

        img{
          width: 14px;
          height: 13px;
          margin-right: 8px;
          margin-top: 14px;
        }
      }
    }

  }

</style>
